/**
 * Created by Alican Köker on 2019-01-22.
 */
import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {EdisonParsedGameData} from "../server/data/EdisonParsedGameData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {EdisonGameModuleConfig} from "../EdisonGameModuleConfig";
import {EdisonGameMode} from "../gameMode/EdisonGameMode";
import {EdisonParsedInitData} from "../server/data/EdisonParsedInitData";
import {TimelineLite} from "gsap";
import { EdisonIndividualWPView } from "../winpresentation/individual/EdisonIndividualWPView";

export class EdisonFeatureController extends BaseController {

    private _gameData:EdisonParsedGameData;
    private _isRestore:boolean = false;
    private _respinToBeStarted:boolean = false;
    private _respinStarted:boolean = false;

    constructor() {
        super();

        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    protected onGameDataParsed(data:EdisonParsedGameData):void {
        this._gameData = data;
        this._isRestore = false;
        this._respinStarted = false;
        this._respinToBeStarted = false;
    }

    protected onInitDataParsed(data:EdisonParsedInitData):void {
        this._isRestore = data.isRestoreState;
        EdisonGameModuleConfig.background.currentMode = data.mode;
    }

    public startRandomFeaturePresentation(featureSym:string):void {
        EdisonGameModuleConfig.randomFeatureIntro.playIntro(featureSym);
    }

    public startFreespin():void {
        let tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            EdisonGameModuleConfig.scatterOverlay.playFreespinWonAnimation();
        });
        tl.add(() => {
            EdisonGameModuleConfig.background.currentMode = EdisonGameMode.FREESPIN;
            EventHandler.dispatchEvent(new GameEvent(EdisonIndividualWPView.SET_MODE, EdisonGameMode.FREESPIN));
        }, 1);
    }

    public updateReelFreespinValue(reelIndex:number):void {
        EdisonGameModuleConfig.freespinController.updateFreespinElements(reelIndex);
    }

    public finishRandomFeaturePresentation():void {
        EdisonGameModuleConfig.randomFeatureIntro.hideIntro();
    }

    public startRespinFeature():void {
        EdisonGameModuleConfig.respinController.startRespinFeature();
        EdisonGameModuleConfig.winPresentationView.reset();
    }

    public addOverlayToRespin(symbol:string, reelIndex:number):void {
        EdisonGameModuleConfig.respinController.activateRespinOverlay(symbol, reelIndex);
    }

    public resetRespinOverlay():void {
        if(!this._isRestore)
            EdisonGameModuleConfig.respinController.reset();
    }

}